import React, { useState } from 'react';
import { map } from "lodash";
import classnames from "classnames";

export const Accordion = ({ list, className, openAll, onClick }) => {
  const [ openedSet, setOpenedSet ] = useState({});

  const handleOnClick = (idx, item) => (event) => {
    if (item.alwaysShow) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    onClick && onClick(item);
    const newValue = !openedSet[idx];
    let resultToSave;
    if (openAll) {
      resultToSave = { ...openedSet, ...{ [idx]: newValue } };
    } else {
      resultToSave = { [idx]: newValue };
    }

    setOpenedSet(resultToSave);
  };

  return (
    <ul className={ classnames("accordion", className) }>
      {
        map(list, (item, idx) => (
          <li className="accordion_item" key={ `accordion-${idx}` }>
            <div
              className={ classnames("accordion_summary", { '-always-show': item.alwaysShow }) }
              onClick={ handleOnClick(idx, item) }
            >
              <div className="accordion_title">{ item.title }</div>
              <div className="accordion_button">
                <div
                  className={
                    classnames(
                      'accordion_button-icon',
                      { '-open': openedSet[idx] || item.alwaysShow }
                    )
                  }
                />
              </div>
            </div>
            {
              (!!openedSet[idx] || item.alwaysShow) && (
                <div
                  className={
                    classnames("accordion_details", { '-always-show': item.alwaysShow })
                  }
                >
                  { item.description }
                </div>
              )
            }
          </li>
        ))
      }
    </ul>
  );
};
